export function validQuantity(value, minimum = 0) {
  const text = String(value == null ? '' : value).trim()
  return /^\d+$/.test(text) && Number(text) >= minimum && Number(text) <= 2147483647
}

export function validPrice(value) {
  const text = String(value == null ? '' : value).trim()
  return /^\d+(\.\d{1,3})?$/.test(text) && Number(text) <= 999999999.999
}

export function validateTiers(tiers, minimum) {
  const rows = (Array.isArray(tiers) ? tiers : []).filter(tier => {
    if (!tier) return false
    return String(tier.minQuantity == null ? '' : tier.minQuantity).trim() ||
      String(tier.price == null ? '' : tier.price).trim()
  })
  if (!rows.length) return ''
  if (rows.some(tier => !validQuantity(tier.minQuantity, Number(minimum)) || !validPrice(tier.price))) {
    return '阶梯数量必须为不小于起购数量的整数，单价最多3位小数且不超过999999999.999'
  }
  const sorted = rows.slice().sort((a, b) => Number(a.minQuantity) - Number(b.minQuantity))
  if (Number(sorted[0].minQuantity) !== Number(minimum)) return '首阶数量必须等于起购数量'
  for (let i = 1; i < sorted.length; i++) {
    if (Number(sorted[i].minQuantity) === Number(sorted[i - 1].minQuantity)) return '价格梯度数量不能重复'
    if (Number(sorted[i].price) > Number(sorted[i - 1].price)) return '阶梯单价不能随购买数量增加而升高'
  }
  return ''
}
